const packageName = 'tiktok';
const sdkUrl = 'https://analytics.tiktok.com/i18n/pixel/events.js';

// eslint-disable-next-line @nx/enforce-module-boundaries
/* eslint-enable */
const snippet = () => {
    if (!window || !document || window.ttq) {
        return;
    }
    window.TiktokAnalyticsObject = 'ttq';
    const ttq = (window['ttq'] =
        window['ttq'] || []);
    ttq.methods = [
        'page',
        'track',
        'identify',
        'instances',
        'debug',
        'on',
        'off',
        'once',
        'ready',
        'alias',
        'group',
        'enableCookie',
        'disableCookie',
    ];
    ttq.setAndDefer = function (t, e) {
        t[e] = function () {
            // eslint-disable-next-line
            t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
        };
    };
    for (let i = 0; i < ttq.methods.length; i++) {
        ttq.setAndDefer(ttq, ttq.methods[i]);
    }
    ttq.instance = function (t) {
        const e = ttq._i[t] || [];
        for (let n = 0; n < ttq.methods.length; n++) {
            ttq.setAndDefer(e, ttq.methods[n]);
        }
        return e;
    };
    ttq.load = function (e, n) {
        const i = sdkUrl;
        ttq._i = ttq._i || {};
        ttq._i[e] = [];
        ttq._i[e]['_u'] = i;
        ttq._t = ttq._t || {};
        ttq._t[e] = +new Date();
        ttq._o = ttq._o || {};
        ttq._o[e] = n || {};
        const element = document.createElement('script');
        element.type = 'text/javascript';
        element.async = !0;
        element.src = i + '?sdkid=' + e + '&lib=ttq';
        const script = document.getElementsByTagName('script')[0];
        if (script && script.parentNode) {
            script.parentNode.insertBefore(element, script);
        }
    };
};
const init = ({ manifest, userId }) => {
    var _a, _b;
    if (!manifest.variables ||
        !manifest.variables['pixelId'] ||
        manifest.variables['enableBrowser'] !== '1') {
        return;
    }
    snippet();
    if (!window.ttq) {
        return;
    }
    window.ttq.load(manifest.variables['pixelId']);
    window.ttq._partner = 'Blotout';
    (_b = (_a = window.ttq.instance(manifest.variables['pixelId'])) === null || _a === void 0 ? void 0 : _a.identify) === null || _b === void 0 ? void 0 : _b.call(_a, {
        external_id: userId,
    });
};

const getProductIdFromMapping = (item, productIdMapping) => {
    if (productIdMapping === '1' && item['variantId']) {
        return item['variantId'];
    }
    if (productIdMapping === '2' && item['sku']) {
        return item['sku'];
    }
    return item['id'];
};
const isPhoneE164 = (phoneNumber) => {
    if (!phoneNumber) {
        return false;
    }
    return /^\+[1-9]\d{10,14}$/.test(phoneNumber);
};

const getEventName = (event, manifestVariables) => {
    if (event === 'PageView') {
        return 'Pageview';
    }
    if (event === 'Purchase') {
        return ((manifestVariables && manifestVariables['purchaseEvent']) ||
            'PlaceAnOrder');
    }
    return event;
};
const prepareData = (data, productIdMapping) => {
    const payload = {};
    if (data['search']) {
        payload['query'] = data['search'];
    }
    if (data['value'] || data['value'] === 0) {
        payload['value'] = data['value'];
    }
    if (data['currency']) {
        payload['currency'] = data['currency'];
    }
    if (data['status']) {
        payload['status'] = data['status'];
    }
    if (data['description']) {
        payload['description'] = data['description'];
    }
    if (data['type']) {
        payload['content_type'] = data['type'];
    }
    if (data['contents'] &&
        Array.isArray(data['contents']) &&
        data['contents'].length > 0) {
        payload['content_type'] = payload['content_type'] || 'product';
        if (data['contents'].length > 1) {
            payload['content_type'] = data['contents'][0].type;
            payload['contents'] = data['contents'].map((item) => {
                const content = {};
                const contentId = getProductIdFromMapping(item, productIdMapping);
                if (contentId) {
                    content['content_id'] = contentId;
                }
                if (item.quantity) {
                    content['quantity'] = item.quantity;
                }
                if (item.item_price || item.item_price === 0) {
                    content['price'] = item.item_price;
                }
                if (item.category) {
                    content['content_category'] = item.category;
                }
                if (item.title) {
                    content['content_name'] = item.title;
                }
                if (item.type) {
                    content['content_type'] = item.type;
                }
                return content;
            });
        }
        else if (data['contents'].length === 1) {
            if (data['contents'][0].item_price ||
                data['contents'][0].item_price === 0) {
                payload['price'] = data['contents'][0].item_price;
            }
            if (data['contents'][0].quantity) {
                payload['quantity'] = data['contents'][0].quantity;
            }
            const contentId = getProductIdFromMapping(data['contents'][0], productIdMapping);
            if (contentId) {
                payload['content_id'] = contentId;
            }
            if (data['contents'][0].title) {
                payload['content_name'] = data['contents'][0].title;
            }
            if (data['contents'][0].type) {
                payload['content_type'] = data['contents'][0].type;
            }
            if (data['contents'][0].category) {
                payload['content_category'] = data['contents'][0].category;
            }
        }
    }
    return payload;
};
const tag = ({ data, eventName, manifestVariables, eventId }) => {
    if (window.ttq &&
        !!manifestVariables['pixelId'] &&
        manifestVariables['enableBrowser'] === '1') {
        const name = data['skipTransformation']
            ? eventName
            : getEventName(eventName, manifestVariables);
        const eventData = data['skipTransformation']
            ? data
            : prepareData(data, manifestVariables['productIdMapping']);
        delete eventData['skipTransformation'];
        window.ttq.instance(manifestVariables['pixelId']).track(name, {
            ...eventData,
            event_id: eventId,
        });
    }
    return {
        sdkVersion: "1.17.0" ,
    };
};

const user = ({ data, manifestVariables }) => {
    var _a, _b;
    if (!window || !window.ttq || !manifestVariables['pixelId']) {
        return;
    }
    const userData = {};
    if (data['email']) {
        userData['email'] = data['email'];
    }
    if (data['phone'] && isPhoneE164(data['phone'])) {
        userData['phone_number'] = data['phone'];
    }
    (_b = (_a = window.ttq.instance(manifestVariables['pixelId'])) === null || _a === void 0 ? void 0 : _a.identify) === null || _b === void 0 ? void 0 : _b.call(_a, userData);
};

// eslint-disable-next-line @nx/enforce-module-boundaries
/* eslint-enable */
const data = {
    name: packageName,
    tag,
    init,
    user,
};
try {
    if (window) {
        if (!window.edgetagProviders) {
            window.edgetagProviders = [];
        }
        window.edgetagProviders.push(data);
    }
}
catch {
    // No window
}

export { data as default };
